export default "__VITE_ASSET__B9_NMIL8__"